import type { CrewArgs } from "../objects/shipmakeup";

export const CREWDEFS: CrewArgs[] = [
	{ name: "hicks", salary: 75, weight: 70, shopChance: 0.8 },
	{ name: "jason", salary: 80, weight: 72, shopChance: 0.5 },
	{ name: "robert", salary: 80, weight: 73, shopChance: 0.4 },
	{ name: "philbert", salary: 80, weight: 75, shopChance: 0.35 },
	{
		name: "mortimer",
		salary: 82.5,
		strength: 12,
		caloricIntake: 5.5,
		weight: 82,
		shopChance: 0.3,
	},
	{
		name: "hudson",
		salary: 85,
		strength: 13,
		caloricIntake: 6,
		weight: 88,
		shopChance: 0.3,
	},
	{
		name: "rodrick",
		salary: 87.5,
		strength: 14,
		caloricIntake: 6.5,
		weight: 92,
		shopChance: 0.27,
	},
	{
		name: "malcolm",
		salary: 90,
		strength: 15,
		caloricIntake: 7.5,
		weight: 95,
		shopChance: 0.25,
	},
	{
		name: "jacklin",
		salary: 95,
		strength: 18,
		caloricIntake: 8,
		weight: 98,
		shopChance: 0.22,
	},
	{
		name: "guterrez",
		salary: 130,
		strength: 24,
		caloricIntake: 10,
		weight: 102,
		shopChance: 0.17,
	},
	{
		name: "chaplain",
		salary: 140,
		strength: 25,
		caloricIntake: 10.5,
		weight: 104,
		shopChance: 0.13,
	},
	{
		name: "mrConk",
		salary: 160,
		strength: 29,
		caloricIntake: 11,
		weight: 121,
		shopChance: 0.04,
	},
];
